import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=f20eef4a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f20eef4a')) {
      api.createRecord('f20eef4a', component.options)
    } else {
      api.reload('f20eef4a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=f20eef4a&", function () {
      api.rerender('f20eef4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f0pnJQiuDB5k/JS/comp/openstreetmap.vue"
export default component.exports